import { AgentSortOption } from '@rematter/frontend-lib-api-client';

import { agentFragment } from './fragmentsAgent';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type AgentRecord = QueryAtomResult<
  typeof agentListQueryAtom
>['agents'][number];

export const agentListQueryAtom = createQueryAtomFactory(
  'admin.agents',
  (params: {
    searchTerm?: string;
    isActive?: boolean;
    sortBy?: AgentSortOption | null;
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    agents: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          isActive: params.isActive,
        },
        sorting: params.sortBy ? [params.sortBy] : undefined,
        pagination: params.pagination,
      },
      entries: agentFragment,
      page: {
        total: true,
      },
    },
  }),
  {
    select: ({ agents }) => ({
      total: agents.page.total ?? 0,
      agents: agents.entries,
    }),
  },
);
